import React, { useState } from "react";
import "./Home.css"
import Card from "./TwoCard/Card";
import Page from '../Component/App-show/Page';
import Footer from '../Component/Footer/Footer';
import Collection from '../Component/Collection/Collection';
import City from "./CityPart/City";
import{Link}from 'react-router-dom'

function Home(){

    const [ham,setHam]=new useState(false);
    const [account,setAccount]=new useState(true);
    const nameval=localStorage.getItem('name')
    // setName(nameval);
    console.log(nameval)
    return (
        <>
        <div className="front">
    {/* <div>
        
            <ul>
            <li className="l1">Get the app</li>
            </ul>
            <ul className="navbar">
            <li className="l2">Invester Relation</li>
            <Link to="/addrest"><li className="l2">Add restarent</li></Link>
            
            {!nameval?(
                <>
                <Link to="/login"><li className="l2">Log-in</li></Link>
                <Link to="/register"><li className="l2">Register</li></Link>
                </>
            ):(
                <>

                <li><h3 className="name1">{nameval}</h3></li>
               <li> <button onClick={()=>{
                    localStorage.clear();
                    window.location.reload(false);
                }}>logout</button></li>
                </>
            )}
            
        </ul>
    </div> */}


<div className="home-nav">
        <ul className="ul-right">
        <li className="l1">Get the app</li>
        </ul>
    <div className="ul-left">
        <ul className="ul-left1" id={ham ? "hidden":""}>

          <li className="l2">Invester Relation</li>
            <Link style={{textDecoration: 'none'}} to="/addrest"><li className="l2">Add restarent</li></Link>
            
            {!nameval?(
                <>
                <Link style={{textDecoration: 'none'}} to="/login"><li className="l2">Log-in</li></Link>
                <Link style={{textDecoration: 'none'}} to="/register"><li className="l2">Register</li></Link>
                </>
            ):(
                <>

                <li><h4 className="name1">{nameval}</h4></li>
                <button >account</button>
                
               <li> <button onClick={()=>{
                    localStorage.clear();
                    window.location.reload(false);
                }}>logout</button></li>
                </>
            )}
            <button className="open-btn">open</button>
            
        
        </ul>
    </div>
    
    </div>




        <div className="logo">
         <h1 className="logo-head">ZOMATO</h1>
         <h3 className="logo-desc">Discover the best food & drinks in Ranchi</h3>
         <input className="search" type={'text'} placeholder='Seach for dish'></input>
        </div>
</div>
 
 {/* #####################  two cards ############################## */}


        <div className="section">
            <Card/> 
            <Card/>  
        </div>

        <Collection/>
        <div className="cityy">
        <City/>
        </div>
        <Page/>
        <Footer/>


        
        </>
    )
}
export default Home;